import React, { Fragment, useContext } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
// Project File Imports
// Material UI Imports
import { List, CardMedia, AppBar } from '@mui/material'
import Box from '@mui/material/Box'
import GroupMenuItem from '../CollapsableMenuItem';
import MenuAccountBar from '../MenuAccountBar';
import { useLocation } from 'react-router';

const MenuContent = (props) => {
  const {
    avatarMenuItems,
    swapMenu,
    onClose,
    menuItems,
    swapMenuWidth,
    logos
  } = props
  const none = { display: 'none' }
  const visible = { display: null, height: 64 }
  let smallLogo = logos.sm;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));  
  if (matches) {
    smallLogo = logos.lg;
  }
  return (
    <Fragment>
      <Box
        onClick={swapMenu}
        sx={(theme) => ({
          display: 'flex',
          height: 64,
        })}>
        <Box sx={{ flex: 1, alignSelf: 'center'}}>
          <AppBar position='sticky' style={{ backgroundColor: theme.palette.background.paper }}>
            <CardMedia
              sx={{ objectFit: 'scale-down' }}
              style={swapMenuWidth ? visible : none}
              component='img'
              alt='logoText'
              src={smallLogo}
            />
            <CardMedia
              sx={{ objectFit: 'scale-down', p: .3 }}
              component='img'
              style={swapMenuWidth ? none : visible}
              alt='logoText'
              src={logos.lg}
            />
          </AppBar>
        </Box>
      </Box>
      <Box sx={{overflow:"auto", height: "calc(100% - 64px - 64px)" }}>
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} component="nav" aria-labelledby="nested-list-subheader">
          {menuItems.map((menuItem, index) => {
            return <GroupMenuItem onClose={onClose} swapMenuWidth={swapMenuWidth} key={index} item={menuItem} />
          })}
        </List>
      </Box>
      <Box>
        <MenuAccountBar avatarMenuItems={avatarMenuItems} />
      </Box>
    </Fragment>
  )
}

export default MenuContent
